(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbIndexTypesDataStore', ['$q', 'smbIndexTypesService', 'smbIndexTypesDataTypes', IndexTypesDataStore]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbIndexTypesDataStore
	 *
	 * @description
	 * Manages the state for the content types configuration.
	 */
	function IndexTypesDataStore($q, smbIndexTypesService, smbIndexTypesDataTypes) {
		var _typeId;
		var _groupId;
		var _indexTypes;
		var _groupIndexTypes;
		var _contentStatus = {
			TagTypeId: 0,
			Value: ''
		};
		var _todoStatus = {
			TagTypeId: 0,
			Value: ''
		};
		var _assignedUserId = {
			TagTypeId: 0,
			Value: ''
		};
		var _assignedDate = {
			TagTypeId: 0,
			Value: ''
		};

		return {
			/**
			 * @ngdoc property
			 * @name smbIndexTypesDataStore.indexTypes
			 * @propertyOf smb-app.smbIndexTypesDataStore
			 *
			 * @description
			 * All content types that belong to the current content type group.
			 */
			get indexTypes() {
				return _indexTypes;
			},

			get groupIndexTypes() {
				return _groupIndexTypes;
			},

			get contentStatusId() { return _contentStatus.TagTypeId; },

			get todoStatusId() { return _todoStatus.TagTypeId; },

			get assignedUserId() { return _assignedUserId.TagTypeId; },

			get assignedDateId() { return _assignedDate.TagTypeId; },

			/**
			 * @ngdoc method
			 * @name smbIndexTypesDataStore.getindexTypes
			 * @methodOf smb-app.smbIndexTypesDataStore
			 *
			 * @description
			 * Loads and returns all content types for a specific content type group by group id.
			 *
			 * @param {Number} groupId The content type group id
			 *
			 * @returns {Deferred} A promise that resolves to a collection of content types.
			 */
			getIndexTypes: getIndexTypes,

			getDocumentTypeGroupIndexTypes: getDocumentTypeGroupIndexTypes,

			setIndexTypes: setIndexTypes
		};

		function getIndexTypes(typeId) {
			if (!typeId) {
				return $q.resolve(_indexTypes);
			} else {
				return smbIndexTypesService.getIndexTypes(typeId)
					.then(function(types) {
						_contentStatus.TagTypeId = types.filter(function filterStatuses(tagtype) {
							return tagtype.TagTypeName.match(/&&_AirBase_Content_Status/);
						})[0].TagTypeId;

						_todoStatus.TagTypeId = types.filter(function filterStatuses(tagtype) {
							return tagtype.TagTypeName.match(/&&_AirBase_ToDo_Status/);
						})[0].TagTypeId;

						_assignedUserId.TagTypeId = types.filter(function filterStatuses(tagtype) {
							return tagtype.TagTypeName.match(/&&_AirBase_Assigned_UserId/);
						})[0].TagTypeId;

						_assignedDate.TagTypeId = types.filter(function filterStatuses(tagtype) {
							return tagtype.TagTypeName.match(/&&_AirBase_Assigned_Date/);
						})[0].TagTypeId;
						return types;
					})
					.then(function (types) {
						_indexTypes = types.filter(function filterStatuses(tagtype) {
							return !(tagtype.TagTypeName.match(/&&_AirBase_.*/));
						})
						.map(function(tt) {
							if (tt.DataType === smbIndexTypesDataTypes.NUMERIC && tt.Constraints && tt.Constraints.DefaultValue) {
								var val = tt.Constraints.DefaultValue;
								tt.Constraints.DefaultValue = val.indexOf('.') >= 0 ? parseFloat(val) : parseInt(val, 10);
							}
							return tt;
						})
						.map(function(tt) {
							if (tt.Constraints) {
								tt.defaultValue = tt.Constraints.DefaultValue;
							}
							return tt;
						});

						_typeId = typeId;
						return types;
					});
			}
		}

		function getDocumentTypeGroupIndexTypes(groupId) {
			if (!groupId) {
				return $q.resolve(_groupIndexTypes);
			} else {
				return smbIndexTypesService.getDocumentTypeGroupIndexTypes(groupId)
					.then(function (types) {
						_groupId = groupId;
						_groupIndexTypes = types
							.filter(function filterStatuses(tagtype) {
								return !(tagtype.TagTypeName.match(/&&_AirBase_.*/));
							})
							.map(function(it) {
								if (it.Constraints) {
									it.defaultValue = it.Constraints.DefaultValue;
								}

								if (it.DataType === smbIndexTypesDataTypes.NUMERIC) {
									it.indexValue = +it.IndexValue;

									if(angular.isDefined(it.defaultValue)) { 
										it.defaultValue = +it.defaultValue;
									}									
								}
								
								return it;
							});
						
						return _groupIndexTypes;
					});
			}
		}

		function setIndexTypes(indexes, documentId, typeId) {
			var tagcollection = indexes
			.filter(function filterTags(t) {
					if (t.indexValue) {
						return t;
					}
				}
			)
			.map(function mapTags(t) {
				var tag = {};
				tag.TagTypeId = t.TagTypeId;

				if (t.DataTypeName === 'Date')
				{
					var date = t.indexValue;

					var mm = date.getMonth() + 1;
					if (mm < 10)
					{
						mm = '0' + mm;
					}

					var dd = date.getDate();
					if (dd < 10)
					{
						dd = '0' + dd;
					}

					tag.Value = [mm, dd, date.getFullYear()].join('');
				}
				else
				{
					tag.Value = t.indexValue;
				}

				return tag;
			});

			return smbIndexTypesService.getIndexTypes(typeId)
			.then(function(types) {
				_contentStatus.TagTypeId = types.filter(function filterStatuses(tagtype) {
					return tagtype.TagTypeName.match(/&&_AirBase_Content_Status/);
				})[0].TagTypeId;

				_todoStatus.TagTypeId = types.filter(function filterStatuses(tagtype) {
					return tagtype.TagTypeName.match(/&&_AirBase_ToDo_Status/);
				})[0].TagTypeId;

				_assignedUserId.TagTypeId = types.filter(function filterStatuses(tagtype) {
					return tagtype.TagTypeName.match(/&&_AirBase_Assigned_UserId/);
				})[0].TagTypeId;

				_assignedDate.TagTypeId = types.filter(function filterStatuses(tagtype) {
					return tagtype.TagTypeName.match(/&&_AirBase_Assigned_Date/);
				})[0].TagTypeId;
			})
			.then(function() {
				return smbIndexTypesService.getDocumentIndexes(documentId);
			})
			.then(function(ft) {
				var value = null;
				value = ft.TypedTags.find(function(tt) {
					return tt.TagTypeName.match(/&&_AirBase_Content_Status/);
				});
				_contentStatus.Value = value.Tags[0] ? value.Tags[0] : '';
				value = null;
				value = ft.TypedTags.find(function(tt) {
					return tt.TagTypeName.match(/&&_AirBase_ToDo_Status/);
				});
				_todoStatus.Value = value.Tags[0] ? value.Tags[0] : '';
				value = null;
				value = ft.TypedTags.find(function(tt) {
					return tt.TagTypeName.match(/&&_AirBase_Assigned_UserId/);
				});
				_assignedUserId.Value = value.Tags[0] ? value.Tags[0] : '';
				value = null;
				value = ft.TypedTags.find(function(tt) {
					return tt.TagTypeName.match(/&&_AirBase_Assigned_Date/);
				});
				_assignedDate.Value = value.Tags[0] ? value.Tags[0] : '';
			})
			.then(function() {
				if (_contentStatus.Value) {
					tagcollection.push(_contentStatus);
				}
				if (_todoStatus.Value) {
					tagcollection.push(_todoStatus);
				}
				if (_assignedUserId.Value) {
					tagcollection.push(_assignedUserId);
				}
				if (_assignedDate.Value) {
					tagcollection.push(_assignedDate);
				}
			})
			.then(function() {
				return smbIndexTypesService.setIndexTypes(tagcollection, documentId);
			})
			.then(function (response) {
				return response;
			});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/indexTypesDataStore.js
// module id = 126
// module chunks = 1